var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_record_voice_over_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.103,
    height: 35.5,
    viewBox: "0 0 41.103 35.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(7.104 6)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31065",
    "data-name": "Path 31065",
    d: "M15.947,26.289C10.959,26.289,1,28.793,1,33.763V37.5H30.895V33.763C30.895,28.793,20.936,26.289,15.947,26.289Zm14.5-18.012-3.139,3.158a6.2,6.2,0,0,1,0,7.268l3.139,3.158c3.774-3.774,3.774-9.473,0-13.583ZM36.631,2,33.585,5.046a14.907,14.907,0,0,1,0,20.067l3.046,3.046C43.918,20.89,43.936,9.567,36.631,2Z",
    transform: "translate(-1 -2)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d40677ee4139f03248c5b2ad41fa5a74.svg";
export { ForwardRef as ReactComponent };